import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { ElMessage } from 'element-plus';

/**
 * 呼叫警報列表
 * @param {*} i18n
 */
export function callHelpAlertList(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#searchModeSelect',
        popover: {
          title: i18n.$t('AlarmList').searchModeSelect,
          description: i18n.$t('AlarmList').searchModeSelectExplain,
        },
      },
      {
        element: '#controlItemSelect',
        popover: {
          title: i18n.$t('AlarmList').controlItemSelect,
          description: i18n.$t('AlarmList').controlItemSelect,
        },
      },
      {
        element: '#sampleIdComponment',
        popover: {
          title: i18n.$t('AlarmList').sampleIdComponment,
          description: i18n.$t('AlarmList').sampleIdComponmentExplain,
        },
      },
      {
        element: '#rapidSearch',
        popover: {
          title: i18n.$t('AlarmList').rapidSearch,
          description: i18n.$t('AlarmList').rapidSearchExplain,
        },
      },
      {
        element: '#advanceSearch',
        popover: {
          title: i18n.$t('AlarmList').advanceSearch,
          description: `
          <p>1.${i18n.$t('AlarmList').advanceSearchExplain}</p>
          <p>2.${i18n.$t('AlarmList').advanceSearchExplainMore}</p>
          `,
          popoverClass: 'explain',
        },
      },

      {
        element: '#lamp',
        popover: {
          title: i18n.$t('AlarmList').lamp,
          description: `
          <p>${i18n.$t('AlarmList').lampExplain}</p>
          <p>${i18n.$t('AlarmList').lampExplainMore}</p>
          <p>${i18n.$t('AlarmList').lampExplainMoreColor}</p>`,
        },
      },

      {
        element: '#handle',
        popover: {
          title: i18n.$t('AlarmList').handle,
          description: `
          <p>${i18n.$t('AlarmList').handleExplain}</p>`,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫警報列表-進階搜尋
 * @param {*} i18n
 */
export function callHelpAlertListAdvanceSearch(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#advanceSearch',
        popover: {
          title: i18n.$t('AlarmList').advanceSearch,
          description: i18n.$t('AlarmList').advanceSearchExplainMore,
          onNextClick: () => {
            if (store.state.alertList.advanceSearchButtonEnable === true) {
              if (store.state.alertList.advanceSearchDialog) {
                driverObj.moveTo(2);
              } else {
                driverObj.destroy();

                ElMessage({
                  showClose: true,
                  message: i18n.$t('DriverTourHelp').ClickAdvanceSearch,
                  type: 'error',
                  duration: 3000,
                });

                setTimeout(() => {
                  driverObj.drive();
                }, 3000);
              }
            } else {
              driverObj.moveNext();
            }
          },
        },
      },

      {
        element: '#controlItemSelect',
        popover: {
          title: i18n.$t('AlarmList').controlItemSelect,
          description: i18n.$t('AlarmList').controlItemSelect,
          onPopoverRender: () => {
            setTimeout(() => {
              driverObj.destroy();
            }, 3000);
          },
        },
      },
      {
        element: '#advanceSearchDialog',
        popover: {
          title: i18n.$t('AlarmList').advanceSearch,
          description: `
          <p>1.${i18n.$t('AlarmList').advanceSearchExplainMore1}</p>
          <p>2.${i18n.$t('AlarmList').advanceSearchExplainMore2}</p>
          <p>3.${i18n.$t('AlarmList').advanceSearchExplainMore3}</p>
          <p>4.${i18n.$t('AlarmList').advanceSearchExplainMore4}</p>`,
        },
        popoverClass: 'explain',
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫警告列表之燈號與圖表
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpAlertListLamp(i18n, store) {
  const tempList = store.state.alertList.alertList;

  let explainText = '';
  if (tempList.length > 0) {
    explainText = i18n.$t('AlarmList').lampExplain;
  } else {
    explainText = i18n.$t('AlarmList').referenceControlItemSettings;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#lamp',
        popover: {
          title: i18n.$t('AlarmList').lamp,
          description: explainText,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
          onNextClick: () => {
            if (store.state.alertList.lampChartDialogVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('AlarmList').clickLampFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '#quarterReview',
        popover: {
          title: i18n.$t('ControlItem').CombinedQuery.QuarterReview,
          description: i18n.$t('AlarmList').quarterReviewExplain,
        },
      },

      {
        element: '#JudgReview',
        popover: {
          title: i18n.$t('ControlItem').CombinedQuery.JudgReview,
          description: i18n.$t('AlarmList').reviewOfJudgmentRulesExplain,
        },
      },

      {
        element: '.plotlyImg',
        popover: {
          title: i18n.$t('AlarmList').alertPoint,
          description: `
          <p>${i18n.$t('AlarmList').alertPointExplain}</p>
          <p>${i18n.$t('AlarmList').alertPointExplainMore}</p>`,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫警告列表之處理
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpAlertListHandle(i18n, store) {
  const tempList = store.state.alertList.alertList;

  let explainText = '';
  if (tempList.length > 0) {
    explainText = i18n.$t('AlarmList').handleExplain;
  } else {
    explainText = i18n.$t('AlarmList').referenceControlItemSettings;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#handle',
        popover: {
          title: i18n.$t('AlarmList').handle,
          description: explainText,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
          onNextClick: () => {
            if (store.state.alertList.advanceHandleDialogVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickHandleButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '#unlockBtn',
        popover: {
          title: i18n.$t('ControlItem').CombinedQuery.unlockButton,
          description: `
          <p>${i18n.$t('AlarmList').unlockButtonExplain}</p>
          <p>${i18n.$t('AlarmList').unlockButtonExplainMore}</p>`,
        },
      },

      {
        element: '#lockBtn',
        popover: {
          title: i18n.$t('ControlItem').CombinedQuery.lockButton,
          description: i18n.$t('AlarmList').lockButtonExplain,
        },
      },

      {
        element: '#joinCalBtn',
        popover: {
          title: i18n.$t('AlarmList').attendQuarterControlLineCalculation,
          description: i18n.$t('AlarmList').isAttendQuarterControlLineCalculation,
        },
      },

      {
        element: '#statusDropDownList',
        popover: {
          title: i18n.$t('Label').status,
          description: i18n.$t('AlarmList').statusExplain,
        },
      },

      {
        element: '#currentFlow',
        popover: {
          title: i18n.$t('Label').currentFlow,
          description: `
          <p>${i18n.$t('AlarmList').currentFlowExplain}</p>
          <p>${i18n.$t('AlarmList').currentFlowExplainMore}</p>`,
        },
      },

      {
        element: '#abnormalReason',
        popover: {
          title: i18n.$t('Label').abnormalReason,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
          <p>${i18n.$t('AlarmList').abnormalReasonExplain}</p>`,
        },
      },

      {
        element: '#checkJudge',
        popover: {
          title: i18n.$t('Label').checkJudge,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
          <p>${i18n.$t('AlarmList').checkJudgeExplain}</p>
          `,
        },
      },

      {
        element: '#describe',
        popover: {
          title: i18n.$t('Label').describe,
          description: i18n.$t('AlarmList').describeExplain,
        },
      },

      {
        element: '#selectStage',
        popover: {
          title: i18n.$t('AlarmList').selectStage,
          description: i18n.$t('AlarmList').selectStageExplain,
        },
      },

      {
        element: '#signOpinion',
        popover: {
          title: i18n.$t('Label').sign_opinion,
          description: i18n.$t('AlarmList').signOpinionExplain,
        },
      },

      {
        element: '#editBtn',
        popover: {
          title: i18n.$t('Label').edit,
          description: i18n.$t('AlarmList').editExplain,
        },
      },

      {
        element: '.btn-confirm',
        popover: {
          title: i18n.$t('Label').confirm,
          description: i18n.$t('AlarmList').confirmExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫製程能力警報列表
 * @param {*} i18n
 */
export function callProcessAnalysisAlarmList(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#timeRange',
        popover: {
          title: i18n.$t('ProcessAnalysisAlarmList').timeRange,
          description: i18n.$t('ProcessAnalysisAlarmList').alertTimeRange,
        },
      },
      {
        element: '#rule',
        popover: {
          title: i18n.$t('ProcessAnalysisAlarmList').rule,
          description: i18n.$t('ProcessAnalysisAlarmList').ruleExplain,
        },
      },
      {
        element: '#ctrlitem',
        popover: {
          title: i18n.$t('Label').ctrlitem,
          description: i18n.$t('ProcessAnalysisAlarmList').controlItemExplain,
        },
      },
      {
        element: '#weekMonthQuarterly',
        popover: {
          title: i18n.$t('ProcessAnalysisAlarmList').weekMonthQuarterly,
          description: i18n.$t('ProcessAnalysisAlarmList').weekMonthQuarterlyExplain,
        },
      },
      {
        element: '#searchBtn',
        popover: {
          title: i18n.$t('Label').filter,
          description: i18n.$t('AlarmList').rapidSearchExplain,
        },
      },
      {
        popover: {
          title: i18n.$t('ProcessAnalysisAlarmList').triggerRule,
          description: `
          <p>${i18n.$t('ProcessAnalysisAlarmList').triggerRuleExplain}</p>
          <p>${i18n.$t('ProcessAnalysisAlarmList').alertTime}</p>
          <p>${i18n.$t('ProcessAnalysisAlarmList').alertEmail}</p>
          <p>${i18n.$t('ProcessAnalysisAlarmList').alertCondition}</p>
          <p>${i18n.$t('ProcessAnalysisAlarmList').triggerRuleExplainMore}</p>`,
          popoverClass: 'explain',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}
